import { FC } from 'react';

import clsx from 'clsx';
import { RiCheckboxCircleFill } from 'react-icons/ri';

import { Chip, ChipProps, ComboboxItem } from '@ui';

import classes from './ChipSelect.module.css';

type CustomChipProps = Omit<ChipProps, 'onClick' | 'children'> & {
  option: ComboboxItem;
  onClick?: (option: ComboboxItem) => void;
};

const CustomChip: FC<CustomChipProps> = ({ option, checked, onClick, ...rest }) => {
  return (
    <Chip
      variant={'outline'}
      color={!checked ? 'secondary' : 'primary'}
      classNames={{
        label: clsx(classes.label, { [classes.selectedMember]: checked })
      }}
      size="sm"
      radius={10000}
      icon={
        <RiCheckboxCircleFill size={12} color="var(--mantine-color-success-6)" />
      }
      tick
      onClick={() => onClick?.(option)}
      checked={checked}
      {...rest}
    >
      {option.label}
    </Chip>
  );
};

export { CustomChip };
